/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateFapDto = {
    /**
     * Legal name of the FAP
     */
    legalName?: string;
    /**
     * Trading name of the FAP
     */
    tradingName?: string;
    /**
     * FAP licence number (unique)
     */
    fapLicenceNumber?: string;
    /**
     * FSPR (Financial Service Providers Register) number
     */
    fsprNumber?: string;
    /**
     * GST number
     */
    gstNumber?: string;
    /**
     * Default authorised rep commission percentage
     */
    commissionPercentage?: number;
    /**
     * Default override percentage (used as fallback when adviser has no override set)
     */
    overridePercentage?: number;
    /**
     * Default override name (used as fallback when adviser has no override name set)
     */
    overrideName?: string;
    /**
     * Default broker fee percentage
     */
    brokerFeePercentage?: number;
    /**
     * Default quoting adviser new business commission percentage
     */
    qaCommissionPercentage?: number;
    /**
     * Default quoting adviser renewal commission percentage
     */
    qaRenewalCommissionPercentage?: number;
    /**
     * FAP status
     */
    status?: UpdateFapDto.status;
    /**
     * Primary contact person name
     */
    primaryContactName?: string;
    /**
     * Primary contact email address
     */
    primaryContactEmail?: string;
    /**
     * Primary contact phone number
     */
    primaryContactPhone?: string;
    /**
     * Banking account name
     */
    bankingAccountName?: string;
    /**
     * Banking account number
     */
    bankingAccountNumber?: string;
    /**
     * Banking reference format
     */
    bankingReferenceFormat?: string;
    /**
     * Additional notes about the FAP
     */
    notes?: string;
};
export namespace UpdateFapDto {
    /**
     * FAP status
     */
    export enum status {
        ACTIVE = 'active',
        INACTIVE = 'inactive',
    }
}

